import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromChannels from './store/channels.reducer'
import { ChannelsEffects } from './store/channels.effects'
import { PermissionModule } from '@tokeet-frontend/permission'
import { TiketChannelEffects } from './store/tiket/effects'
import { GVRChannelEffects } from './store/gvr/effects'
import { RentalsUnitedChannelEffects } from './store/rentals-united/effects'
import { HoliduChannelEffects } from './store/holidu/effects'
import { HVMIChannelEffects } from './store/hvmi/effects'
import { CtripChannelEffects } from './store/ctrip/effects'
import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'
import { RentalsLibraryModule } from '@tokeet-frontend/rentals'
import { HopperChannelEffects } from './store/hopper/effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('channels-lib', fromChannels.channelsReducer),
    EffectsModule.forFeature([
      ChannelsEffects,
      GVRChannelEffects,
      RentalsUnitedChannelEffects,
      HVMIChannelEffects,
      HoliduChannelEffects,
      TiketChannelEffects,
      CtripChannelEffects,
      HopperChannelEffects,
    ]),
    Tv3PlatformModule,
    RentalsLibraryModule,
    PermissionModule,
  ],
})
export class ChannelsLibraryModule {}
